import { TFunction } from "i18next";
import { Text } from "@pentabd/ui";

export const Column = (t: TFunction<"translation", undefined>) => {
  return [
    {
      id: 2,
      key: "id",
      name: "ক্র: নং",
      render: (id: number) => (
        <Text color="subtitle1" className="text-nowrap">
          {id}
        </Text>
      ),
    },
    {
      id: 3,
      key: "nameBn",
      name: "পদের নাম",
      render: (nameBn: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {nameBn}
        </Text>
      ),
    },
    {
      id: 4,
      key: "date",
      name: "পদোন্নতির তাং",
      render: (date: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {date}
        </Text>
      ),
    },

    {
      id: 5,
      key: "total",
      name: "পদোন্নতি প্রাপ্ত কর্মকর্তা/কর্মচারীর সংখ্যা",
      render: (total: number) => (
        <Text color="subtitle1" className="text-nowrap">
          {total}
        </Text>
      ),
    },
    {
      id: 6,
      key: "totalVacancy",
      name: "মন্তব্য",
    },
  ];
};
